import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { IconButton, useTheme } from 'react-native-paper'

interface ReplayControlsProps {
  onPlay: () => void
  onPause: () => void
  onNext: () => void
  onPrevious: () => void
  isPlaying: boolean
  disabled?: boolean
}

export const ReplayControls = ({
  onPlay,
  onPause,
  onNext,
  onPrevious,
  isPlaying,
  disabled = false,
}: ReplayControlsProps) => {
  const theme = useTheme()

  return (
    <View style={styles.container}>
      <IconButton
        icon="skip-previous"
        size={24}
        onPress={onPrevious}
        disabled={disabled}
        style={styles.iconButton}
      />
      <IconButton
        mode="contained-tonal"
        icon={isPlaying ? 'pause' : 'play'}
        size={32}
        onPress={isPlaying ? onPause : onPlay}
        disabled={disabled}
        style={[styles.playButton, styles.iconButton]}
      />
      <IconButton
        icon="skip-next"
        size={24}
        onPress={onNext}
        disabled={disabled}
        style={styles.iconButton}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  playButton: {},
  iconButton: {
    margin: 0,
    padding: 0,
  },
})
